import store from '@/store/index';
import permissions from '@/UserPermissions/PermissionGroups';

const CanDirective = {
    inserted(el, binding, vnode){
        if(readOnlyMode(binding.value)){
            vnode.elm.parentNode.removeChild(vnode.elm);
        }

        const bypassPermission = binding.arg;
        if(bypassPermission === true || !binding.value)
            return;

        const userPermissions = store.getters.getUserPermissions.permissions;
        if (!((userPermissions & binding.value) === binding.value))
            vnode.elm.parentNode.removeChild(vnode.elm);
    }
}

const CanAnyDirective = {
    inserted(el, binding, vnode){
        if(readOnlyMode(binding.value)){
            vnode.elm.parentNode.removeChild(vnode.elm);
        }

        const bypassPermission = binding.arg;
        if(bypassPermission === true || !binding.value)
            return;

        const userPermissions = store.getters.getUserPermissions.permissions;
        if (!((userPermissions & binding.value) !== 0))
            vnode.elm.parentNode.removeChild(vnode.elm);
    }
}

const readOnlyMode = (perms) => {
    if(!perms || perms <= 0){
        return false;
    }

    const portfolio = store.getters.getActivePortfolio;
    if(portfolio.read_only_mode){
        let readPerms = 0;
        Object.entries(permissions.Permissions).forEach(([key, value]) => {
            if(key.includes("READ"))
                readPerms |= value;
        });

        if((readPerms & perms) != perms)
            return true;
        
        return false;
    }
}

function userCan(perms, bypassPermission = false){
    if(readOnlyMode(perms))
        return false;

    if(bypassPermission === true)
        return true;

    const userPermissions = store.getters.getUserPermissions.permissions;
    if (!((userPermissions & perms) === perms) && perms !== 0)
        return false;
    
    return true;
}

function userCanAny(perms, bypassPermission = false){
    if(readOnlyMode(perms))
        return false;

    if(bypassPermission === true)
        return true;

    const userPermissions = store.getters.getUserPermissions.permissions;
    if (!((userPermissions & perms) !== 0) && perms !== 0)
        return false;
    
    return true;
}

export default{
    CanDirective,
    CanAnyDirective,
    userCan,
    userCanAny
}